var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEvening(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "sun",
    clipPath: "url(#clip0_1981_1124)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.3587 10.286C16.3587 13.7976 13.5115 16.6444 10.0006 16.6444C6.48988 16.6444 3.64185 13.7976 3.64185 10.286C3.64185 6.77477 6.48988 3.92725 10.0006 3.92725C13.5115 3.92725 16.3587 6.77477 16.3587 10.286Z",
    fill: "#FFCE31"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.0007 16.7823C6.41827 16.7823 3.50391 13.8681 3.50391 10.2861C3.50391 6.70351 6.41827 3.78931 10.0007 3.78931C13.5827 3.78931 16.4966 6.70351 16.4966 10.2861C16.4966 13.8681 13.5827 16.7823 10.0007 16.7823ZM10.0007 4.50354C6.81226 4.50354 4.21813 7.09783 4.21813 10.2861C4.21813 13.4741 6.81226 16.0681 10.0007 16.0681C13.1887 16.0681 15.7823 13.4741 15.7823 10.2861C15.7823 7.09783 13.1887 4.50354 10.0007 4.50354Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M20 10.6435H18.1108V9.92896H20V10.6435Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M1.88898 10.6435H0V9.92896H1.88898V10.6435Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M10.396 2.17426H9.68188V0.286133H10.396V2.17426Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M4.05817 5.13527L2.7356 3.81152L3.24105 3.3064L4.56362 4.63015L4.05817 5.13527Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M15.9429 5.13527L15.4377 4.63015L16.7598 3.3064L17.2649 3.81152L15.9429 5.13527Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M10.396 20.286H9.68188V18.3972H10.396V20.286Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M3.24105 17.2656L2.7356 16.7605L4.05817 15.4368L4.56362 15.9419L3.24105 17.2656Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M16.7598 17.2656L15.4377 15.9419L15.9429 15.4368L17.2649 16.7605L16.7598 17.2656Z",
    fill: "#37474F"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M16.5427 13.175C16.186 13.175 15.8427 13.2306 15.5188 13.3333C15.1366 12.2067 14.0966 11.3972 12.8704 11.3972C11.5549 11.3972 10.4538 12.3294 10.1488 13.5844C9.82322 13.3311 9.42156 13.1756 8.98156 13.1756C7.90767 13.1756 7.03711 14.0706 7.03711 15.1756C7.03711 15.4439 7.09045 15.6983 7.18378 15.9328C6.99822 15.8789 6.80656 15.8417 6.60489 15.8417C5.41156 15.8417 4.44434 16.8367 4.44434 18.0639C4.44434 19.2911 5.41156 20.2861 6.60489 20.2861H16.5432C18.4521 20.2861 19.9999 18.695 19.9999 16.7306C19.9999 14.7667 18.4521 13.175 16.5427 13.175Z",
    fill: "#E1E8ED"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1981_1124"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.286133)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvening);
export default __webpack_public_path__ + "static/media/evening.27e29f022103c3219b39de7e6907d402.svg";
export { ForwardRef as ReactComponent };